import { createSelector } from '@reduxjs/toolkit';
import { selectBalconyValue } from './selectBalconyValue';
import { EBalconyType } from '../../../../packages/JsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Балкон', value: EBalconyType.Balcony },
  { label: 'Лоджия', value: EBalconyType.Loggia },
];

export const selectBalconyFilter = createSelector(selectBalconyValue, value => ({
  label: 'Балкон/Лоджия',
  value,
  options: OPTIONS,
}));
